import { getHslLightness } from '~/utils/getHslLightness'
import { buildFontFaceCss, formatCssFontFamily, isFontFileUrl, normalizeThemeFont } from '~/utils/theme-font'

export default defineNuxtPlugin(() => {
  const themeStyleStore = useThemeStyleStore()
  const theme = computed(() => ({
    primaryColor: `rgb(${themeStyleStore.primaryColor.red}, ${themeStyleStore.primaryColor.green}, ${themeStyleStore.primaryColor.blue})`,
    secondaryColor: `rgb(${themeStyleStore.secondaryColor.red}, ${themeStyleStore.secondaryColor.green}, ${themeStyleStore.secondaryColor.blue})`,
    font: normalizeThemeFont(themeStyleStore.font),
  }))
  const calculatedTheme = computed(() => ({
    primaryText: getHslLightness(theme.value.primaryColor) > 0.55 ? 'black' : 'white',
    secondaryText: getHslLightness(theme.value.secondaryColor) > 0.55 ? 'black' : 'white',
    primaryTextReversed: getHslLightness(theme.value.primaryColor) > 0.55 ? 'white' : 'black',
    secondaryTextReversed: getHslLightness(theme.value.secondaryColor) > 0.55 ? 'white' : 'black',
  }))

  const fontHref = computed(() => {
    const cdn = theme.value.font?.cdn
    if (!cdn) return ''
    if (cdn.includes('fonts.googleapis.com')) {
      if (cdn.includes('display=')) {
        return cdn.replace(/([?&])display=[^&]*/, '$1display=swap')
      }
      return `${cdn}${cdn.includes('?') ? '&' : '?'}display=swap`
    }
    return cdn
  })

  useHead(() => ({
    style: [
      {
        children: `
      :root {
        --wft-primary-color: ${theme.value.primaryColor};
        --wft-secondary-color: ${theme.value.secondaryColor};
        --wft-font-family: ${theme.value.font?.fontFamily ? formatCssFontFamily(theme.value.font.fontFamily) : ''};

        --wft-primary-opacity-color: rgba(${themeStyleStore.primaryColor.red}, ${themeStyleStore.primaryColor.green}, ${themeStyleStore.primaryColor.blue}, 0.1);
        --wft-secondary-opacity-color: rgba(${themeStyleStore.secondaryColor.red}, ${themeStyleStore.secondaryColor.green}, ${themeStyleStore.secondaryColor.blue}, 0.1);
        --wft-primary-text-color: ${calculatedTheme.value.primaryText};
        --wft-secondary-text-color: ${calculatedTheme.value.secondaryText};
        --wft-primary-text-reversed: ${calculatedTheme.value.primaryTextReversed};
        --wft-secondary-text-reversed: ${calculatedTheme.value.secondaryTextReversed};
      }
      `,
      },
      ...(theme.value.font?.cdn && isFontFileUrl(theme.value.font.cdn) ? [{
        children: buildFontFaceCss(theme.value.font.fontFamily, theme.value.font.cdn),
      }] : []),
    ],
    link: [
      { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
      { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: 'anonymous' },
      {
        rel: 'stylesheet',
        href: () => themeStyleStore.css,
      },
      ...(fontHref.value && !isFontFileUrl(fontHref.value) ? [
        { rel: 'preload' as const, href: fontHref.value, as: 'style' as const },
        {
          rel: 'stylesheet',
          href: fontHref.value,
        },
      ] : []),
    ],
  }))
})
